import { render, staticRenderFns } from "./userManagementDetails.vue?vue&type=template&id=bd392180&scoped=true"
import script from "./userManagementDetails.vue?vue&type=script&lang=js"
export * from "./userManagementDetails.vue?vue&type=script&lang=js"
import style0 from "./userManagementDetails.vue?vue&type=style&index=0&id=bd392180&prod&lang=less&scoped=true"
import style1 from "./userManagementDetails.vue?vue&type=style&index=1&id=bd392180&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd392180",
  null
  
)

export default component.exports